import { useEffect, useState } from "react";
import Messages from "duck/ui/chat/components/Messages";
import { subthreadManager } from "duck/ui/chat/subthreadManager";
import { ChatMessage } from "duck/ui/chat/types";

interface Props {
  threadId: string;
}

/**
 * Displays messages for a specific subthread.
 * Subscribes to subthreadManager for messages (fetched by parent SubthreadMessage component).
 */
const SubthreadMessages = ({ threadId }: Props) => {
  const [messages, setMessages] = useState<ChatMessage[]>(
    () => subthreadManager.getState(threadId).messages
  );
  const [isStreaming, setIsStreaming] = useState<boolean>(
    () => subthreadManager.getState(threadId).isStreaming
  );

  // subscribe to updates from subthreadManager
  useEffect(() => {
    const unsubscribe = subthreadManager.subscribe(threadId, (state) => {
      setMessages(state.messages);
      setIsStreaming(state.isStreaming);
    });

    return unsubscribe;
  }, [threadId]);

  return (
    <div className="gap-2 flex flex-col">
      <Messages
        messages={messages}
        isStreaming={isStreaming}
        threadId={threadId}
        isSubthread
      />
    </div>
  );
};

export default SubthreadMessages;
